import apiClient from '@/plugins/axios'

export default {
  getMunicipios() {
    return apiClient.get('municipio')
  },

  getMunicipio(id) {
    return apiClient.get(`municipio/${id}`)
  },

  postMunicipio(municipio) {
    return apiClient.post(`municipio`, { municipio })

  },

  putMunicipio(id, municipio) {
    return apiClient.put(`municipio/${id}`, { municipio })

  },

  deleteMunicipio(id) {
    return apiClient.delete(`municipio/${id}`)

  },

  getDropDown() {
    return apiClient.get(`municipio/dropdown`)
  },

  getDropDownUf() {   
    return apiClient.get(`uf/dropdown`)
  }

}


// WEBPACK FOOTER //
// ./src/views/Municipio/_services/MunicipioService.js